const form = document.querySelector<HTMLFormElement>('#login')!;
const error = document.querySelector<HTMLElement>('#error')!;

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  error.textContent = '';
  const data = Object.fromEntries(new FormData(form));
  const res = await fetch('/api/login', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (res.ok) location.assign('/');
  else error.textContent = res.status === 429 ? 'Too many attempts. Wait a minute.' : 'Wrong username or password.';
});
